// extracted by mini-css-extract-plugin
export default {"Container":"Cards_Container__lMJOw","Cards-wrapper":"Cards_Cards-wrapper__zeA39","card":"Cards_card__j+NVO","icon-wrapper":"Cards_icon-wrapper__sjJk3"};